import { NgModule } from '@angular/core';
import { BreadcrumbComponent } from './breadcrumb.component';
import { BreadcrumbService } from './breadcrumb.service';

@NgModule({
    declarations: [BreadcrumbComponent],
    exports: [BreadcrumbComponent],
    providers: [BreadcrumbService]
})
export class BreadcrumbModule {}
